import React from "react";
import "./simpleButtonWrapper.css";
import classNames from "classnames";

const SimpleButtonWrapper = (props) => {
  const { position, lastButton, children, style } = props;
  return (
    <div
      style={style}
      className={classNames(
        "simple_btn",
        { right: position === "right" },
        { left: position === "left" },
        { "last-button": lastButton }
      )}
    >
      {children}
    </div>
  );
};

export default SimpleButtonWrapper;
